/** for use with OAuthClient to tie an entityId back to the transcend model it pertains to */
export enum OAuthEntityType {
  /** entityId is a User id */
  User = 'User',
  /** entityId is an Organization id */
  Organization = 'Organization',
  /** entityId is a DataSilo id */
  DataSilo = 'DataSilo',
}
